import PageHeading from '../../components/PageHeading';
import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import OrderCreateForm from '../../components/OrderCreateForm';
import { pageLoader } from '../../services/PageLoader';
import { LazyPage } from '../../components/LazyPage';

export default class NewOrderPage extends Component {
  constructor() {
    super();

    pageLoader.addPageToLazyLoadedPages('invoices');
  }

  render() {
    return (
      <LazyPage>
        <PageHeading>Новый заказ</PageHeading>
        <Row>
          <Col xs>
            <OrderCreateForm/>
          </Col>
        </Row>
      </LazyPage>
    );
  }
}
